// extracted by mini-css-extract-plugin
module.exports = {"burger":"style_burger__3erum","line":"style_line__Xcg7g","line1":"style_line1__3rMYz","active":"style_active__21sJV","line2":"style_line2__225rq","line3":"style_line3__3KjB_"};